import { render, staticRenderFns } from "./SingleOrders.vue?vue&type=template&id=a248f5d8&"
import script from "./SingleOrders.vue?vue&type=script&lang=ts&"
export * from "./SingleOrders.vue?vue&type=script&lang=ts&"
import style0 from "./SingleOrders.vue?vue&type=style&index=0&id=a248f5d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports